export const SNOWFLAKE_REPORT_PAGINATION = 'snowflake-report-pagination-usage';
export const UE_REPORT_PAGINATION = 'ue-report-pagination-usage';
export const CRM_REPORT_PAGINATION = 'crm-report-pagination-usage';
export const OTHER_REPORT_PAGINATION = 'other-report-pagination-usage';
export const PAGINATION_TRACKING_WAIT_TIME_MS = 30000;
export const PAGINATION_TRACKING_METRIC_NAME = 'paginated-report-rows-viewed';
export const REPORT_EXPORT_TRACKING = 'report-export-count';
export const REPORT_EXPORT_FAILURE_TRACKING = 'report-export-failure-count';
export const INLINE_DATE_RANGE_LABEL_INTERACTION = 'inline-date-range-label-interaction';
export const INLINE_DATE_RANGE_LABEL_RENDERED = 'inline-date-range-label-rendered';
export const INLINE_COMPARISON_LABEL_INTERACTION = 'inline-comparison-label-interaction';
export const INLINE_COMPARISON_LABEL_RENDERED = 'inline-comparison-label-rendered';
export const INLINE_MULTI_ACCOUNT_LABEL_INTERACTION = 'inline-multi-account-label-interaction';
export const INLINE_MULTI_ACCOUNT_LABEL_RENDERED = 'inline-multi-account-label-rendered';
export const INLINE_LIMITED_DATA_WARNING_LABEL_INTERACTION = 'inline-limited-data-warning-label-interaction';
export const INLINE_LIMITED_DATA_INCORRECT_RENDER = 'inline-limited-data-incorrect-render';
export const RENDERED_NO_DATA = 'report-rendered-no-data';
export const NO_DATA_TYPES = {
  STANDARD: 'standard',
  CUSTOM: 'custom'
};
export const REPORT_HOVER_TIME = 'report-hover-time';
export const REPORT_CONTENT_RESOLVE_TYPES = {
  STANDARD_RESOLVE: 'standard_resolve',
  UNIFIED_RESOLVE: 'unified_resolve'
};
export const REPORT_CONTENT_RESOLVE_TYPE = 'report-content-resolve-type';
export const UNIFIED_VIZ_RESOLVE_VALIDATION = 'unified-viz-resolve-validation';
export const EDIT_GOALS_MODAL_RENDERED = 'edit-goals-modal-rendered';
export const PERSONA_LABEL_CLICK = 'persona-label-click';
export const DELTA_LABEL_USAGE = 'delta-label-usage';